import { render, staticRenderFns } from "./LoginSelectTenant.vue?vue&type=template&id=701873ac&scoped=true&"
import script from "./LoginSelectTenant.vue?vue&type=script&lang=js&"
export * from "./LoginSelectTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701873ac",
  null
  
)

export default component.exports